/**
 * AppICEMAP — Application entry point.
 * Initializes CSS, theme, and mounts the application.
 */

// CSS imports — tokens
import "../css/tokens/index.css";

// CSS imports — base
import "../css/base/reset.css";
import "../css/base/theme-transition.css";
import "../css/base/typography.css";
import "../css/base/scrollbar.css";

// CSS imports — Phosphor Icons (font-face + icon classes)
import "@phosphor-icons/web/regular";

// CSS imports — Leaflet
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

// CSS imports — components
import "../css/components/marker.css";
import "../css/components/popup-card.css";
import "../css/components/poi-marker.css";
import "../css/components/map-viewer.css";
import "../css/components/bottom-sheet.css";
import "../css/components/toast.css";
import "../css/components/skeleton.css";
import "../css/components/offline-banner.css";
import "../css/components/empty-state.css";
import "../css/components/app-shell.css";
import "../css/components/sheet-components.css";
import "../css/components/category-pills.css";
import "../css/components/search-bar.css";
import "../css/components/report-card.css";
import "../css/components/quick-report.css";
import "../css/components/dialog.css";
import "../css/components/confirm-dialog.css";
import "../css/components/detail-sheet.css";
import "../css/components/photo-gallery.css";
import "../css/components/confirmation-bar.css";
import "../css/components/comments.css";
import "../css/components/auth-header-widget.css";

// CSS imports — auth + profile + push
import "../css/components/auth.css";
import "../css/components/profile.css";
import "../css/components/push.css";

// CSS imports — stats + pwa
import "../css/components/stats.css";
import "../css/components/pwa.css";

// CSS imports — utilities
import "../css/utilities/layout.css";
import "../css/utilities/scroll-lock.css";
import "../css/utilities/responsive.css";

// App bootstrap — deferred until DOM is ready
import { bootstrap } from "./app.js";

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", bootstrap);
} else {
	bootstrap();
}
